import { useRef } from 'react'
import { useEngine } from './use_engine.js'

// The renderer never re-renders through React — the canvas is a ref and the
// rAF loop lives in useEngine. React only owns the element, never the frames.
export default function Visualization({ piece, backend = 'canvas2d', theme, morph, className, style, canvasRef }) {
  // The caller may hand in its own ref — capture needs the element, and
  // reaching for it with a querySelector would make the stage's markup part
  // of the contract.
  const own = useRef(null)
  const ref = canvasRef || own
  useEngine(ref, piece, { backend, theme, morph })
  return <canvas ref={ref} className={className} style={{ display: 'block', width: '100%', height: '100%', ...style }} />
}
